
import {Component, OnInit , ElementRef, ViewChild} from '@angular/core';
import { DownloadChartService } from '../services/download-chart.service';
import { CheckTokenService } from '../../common/services/check-token.service';
import { Chart } from 'chart.js';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
//import {Storage} from '@google-cloud/storage';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CheckProfileService } from '../../common/services/check-profile.service';
import { AuthorizationService } from '../../common/services/authorization.service';
import { Camambert, DownloadChart } from '../models/camambert.model';




@Component({
  selector: 'app-statistique',
  templateUrl: './statistique.component.html',
  styleUrls: ['./statistique.component.css']
})


export class StatistiqueComponent implements OnInit {

    httpOptions = {headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    
    chart = [];
    connectionChart = [];
    download: Number;
    moyenneconnexion: Number;
    camembert: Camambert[]
    downloadChart: DownloadChart[]
    nbreSouscripteur: Number
  
  constructor(private authorizationService: AuthorizationService, private checkProfileService: CheckProfileService, private checkTokenService: CheckTokenService, private elementRef: ElementRef,  private http: HttpClient, private statistiqueService: DownloadChartService) { 
     this.authorizationService.isClient();
  }

  ngOnInit() {
    this.checkTokenService.verifyToken();
    this.statistiqueService.getMoyenneConnexion().subscribe( data => { 
      this.moyenneconnexion = data 
      //this.nbreSouscripteur = 2
      this.statistiqueService.countSouscripteur().subscribe( nbre => this.nbreSouscripteur = nbre )
    })
    this.statistiqueService.getDownloaded().subscribe( data => { this.download = data })
    this.downloadChartBar();
    this.connectionChartBar();
  }

  intInMonth(month): string{
    const mois = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Decembre']
    return mois[month-1]
  }
  downloadChartBar() {
    let allLabels = [];
    let total = [];
    let htmlRef = this.elementRef.nativeElement.querySelector('#canvas');
      // const c = [
      //   {annee: 2010, total: 785},
      //   {annee: 2011, total: 154},
      //   {annee: 2012, total: 658}
      // ]
      
      this.statistiqueService.getDownloadedByYear().subscribe(
        data => {
            //this.downloadChart = c
            this.downloadChart = data
            if(this.downloadChart.length > 0){
              for(let i = 0; i< this.downloadChart.length; i++){
                allLabels[i] = this.downloadChart[i].annee
                total[i] = this.downloadChart[i].total
              }
              
              this.chart = new Chart(htmlRef, {
                type: 'bar',
                data: {
                  labels: allLabels,
                  datasets: [
                    {
                      data: total,
                      backgroundColor: [
                        "#3498db",
                        "#3498db",
                        "#3498db",
                        "#3498db",
                        "#3498db",
                        "#3498db",
                        "#3498db",
                        "#3498db",
                        "#3498db",
                        "#3498db",
                        "#3498db",
                        "#3498db"
                      ],
                      borderColor: [
                        "#2ecc71",
                        "#3498db",
                        "#95a5a6",
                        "#9b59b6",
                        "#f1c40f",
                        "#e74c3c",
                        "#34495e"
                      ]
                      
                      
                    }
                  ]
                },
                options: {
                  legend: {
                    display: false
                  },
                  scales: {
                    xAxes: [{
                      display: true
                    }],
                    yAxes: [{
                      display: true
                    }]
                  }
                 
                }
              })// chart

            }//fin-if
        });
   
    
        
  }

  connectionChartBar(){
    /*const c = [
      {mois: 1, total: 785},
      {mois: 2, total: 154},
      {mois: 3, total: 658}
    ]*/
    let temp_max = [];
    let alldates = [];
    let htmlRef = this.elementRef.nativeElement.querySelector('#connection-canvas');
    
    this.statistiqueService.getCamambert().subscribe(
      data => {
          // this.camembert = c
          this.camembert = data
          if(this.camembert.length > 0){
            for(let i = 0; i< this.camembert.length; i++){
              alldates[i] = this.intInMonth(this.camembert[i].mois)
              temp_max[i] = this.camembert[i].total
            }
                
            this.connectionChart = new Chart(htmlRef, {
              type: 'doughnut',
              data: {
                labels: alldates,
                datasets: [
                  {
                    data: temp_max,
                    backgroundColor: [
                      "#ffb0c1",
                      "#9ad0f5",
                      "#ffe6aa",
                      "#a4dfdf"
                    ],
                    borderColor: [
                      "#ff6384",
                      "#3ca4eb",
                      "#ffce56",
                      "#4bc0c0"
                    ]
                  }
                ]
              },
              options: {
                legend: {
                  display: false
                },
                scales: {
                  xAxes: [{
                    display: false
                  }],
                  yAxes: [{
                    display: false
                  }]
                }
              }
            })//chart
          }//fin-if
      });
  }

 

}




// WEBPACK FOOTER //
// ./src/app/admin-app/statistique/statistique.component.ts